/**
 * Константы, содержащие значения единиц времени в милисекундах
 */
export const SECONDS = 1000;

export const MINUTES = SECONDS * 60;

export const HOURS = MINUTES * 60;

export const DAYS = HOURS * 24;
